import { makeStyles, createStyles, MuiTheme } from '@kis-technologies/kis-ui';

export const useStyles = makeStyles((theme: MuiTheme) =>
  createStyles({
    orderListViewOuterContainer: {
      alignItems: 'center',
      justifyContent: 'center',
      padding: '0px 24px 0px 24px',
      minWidth: '100%',
      background: 'transparent',
      display: 'flex',
      flexDirection: 'column'
    },
    orderListViewInnerContainer: {
      background: 'white',
      color: '#2A2A2A',
      minWidth: '100%',
      borderRadius: '8px',
      height: '805px',
      boxShadow: '0 3px 9px 0 rgba(0,0,0,0.2)',
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      padding: '56px 112px 56px 112px',
      margin: '0px 0px 32px 0px',
      [theme.breakpoints.down('lg')]: {
        height: '1640px',
        padding: '48px 16px 56px 32px'
      }
    },
    orderListTableBox: {
      padding: '0px 8px 0px 8px',
      background: 'transparent'
    },
    orderListViewColumn: {
      flex: '1 1 0%',
      background: 'transparent',
      whiteSpace: 'normal'
    },
    tableContainer: {
      width: 'calc(100% - 10px)',
      margin: '0 5px 40px',
      borderCollapse: 'separate',
      borderSpacing: '0 20px'
    },
    tableHeaderCell: {
      fontSize: 24,
      fontWeight: 600,
      padding: '12px 24px',
      backgroundColor: 'white',
      borderBottom: 'none',
      '&:first-child': { paddingLeft: '40px' },
      '&:last-child': { paddingRight: '40px', textAlign: 'right' }
    },
    tableBodyCell: {
      padding: '24px',
      borderBottom: 'none',
      '&:first-child': { paddingLeft: '40px' },
      '&:last-child': { paddingRight: '40px', textAlign: 'right' }
    }
  })
);
